import { Reducer } from 'react'
import { PlanState, PlanTypes, PlanAction } from '../types/settings'

const initialState: PlanState = {
  access_token: '',
  isAuthenticated: false,
  loading: false,
  email: '',
  error: '',
  phone_number: '',
}

const settingsReducer: Reducer<PlanState, PlanAction> = (
  state = initialState,
  action: PlanAction
): PlanState => {
  switch (action.type) {
    case PlanTypes.CHANGE_PASSWORD_REQUEST:
      return {
        ...state,
        email: '',
        loading: true,
        error: '',
      }
    case PlanTypes.CHANGE_PASSWORD_SUCCESS:
      return {
        ...state,
        email: action.payload.email,
        loading: false,
        error: '',
      }
    case PlanTypes.CHANGE_PASSWORD_ERROR:
      return {
        ...state,
        error: action.payload.error,
      }
      case PlanTypes.UPDATE_PROFILE_REQUEST:
        return {
          ...state,
          email: '',
          loading: true,
          error: '',
        }
      case PlanTypes.UPDATE_PROFILE_SUCCESS:
        return {
          ...state,
          email: action.payload.email,
          loading: false,
          error: '',
        }
      case PlanTypes.UPDATE_PROFILE_ERROR:
        return {
          ...state,
          error: action.payload.error,
        }
        case PlanTypes.RESET_PIN_REQUEST:
          return {
            ...state,
            email: '',
            loading: true,
            error: '',
          }
        case PlanTypes.RESET_PIN_SUCCESS:
          return {
            ...state,
            email: action.payload.email,
            loading: false,
            error: '',
          }
        case PlanTypes.RESET_PIN_ERROR:
          return {
            ...state,
            error: action.payload.error,
          }
          case PlanTypes.GET_NOK_REQUEST:
            return {
              ...state,
              email: '',
              loading: true,
              error: '',
            }
          case PlanTypes.GET_NOK_SUCCESS:
            return {
              ...state,
              email: action.payload.email,
              loading: false,
              error: '',
            }
          case PlanTypes.GET_NOK_ERROR:
            return {
              ...state,
              error: action.payload.error,
            }
          case PlanTypes.POST_NOK_REQUEST:
          return {
            ...state,
            email: '',
            loading: true,
            error: '',
          }
        case PlanTypes.POST_NOK_SUCCESS:
          return {
            ...state,
            email: action.payload.email,
            loading: false,
            error: '',
          }
        case PlanTypes.POST_NOK_ERROR:
          return {
            ...state,
            error: action.payload.error,
          }
    
    default:
      return state
  }
}

export { settingsReducer }
